import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Container = styled.div`
  flex: none;
  background-color: ${(props) => props.theme.colours.nav};
  color: white;
  width: 6rem;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`

/** NavLeft contains a sticky left navigation bar, typically rendered
    inside a top-level Layout. */
const NavLeft = ({ children }) => <Container>{children}</Container>
NavLeft.propTypes = {
  children: PropTypes.any,
}

export default NavLeft
